import { EDUCATION } from "../data";
import { Reveal, Eyebrow } from "./AmberCallout";

const Education = () => (
  <section id="education" data-testid="education-section" className="py-20 sm:py-28 lg:py-32 scroll-mt-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>Education</Eyebrow>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink max-w-2xl leading-tight">
          Three institutions, three countries, one thread: understanding people.
        </h2>
      </Reveal>
      <div className="mt-12 max-w-3xl">
        {EDUCATION.map((ed, i) => (
          <Reveal key={ed.id} delay={i * 0.08}>
            <div
              data-testid={`education-card-${ed.id}`}
              className="relative pl-8 pb-12 last:pb-0 border-l border-line"
            >
              <span
                className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-terra"
                aria-hidden="true"
              />
              <p className="text-xs font-mono uppercase tracking-wider text-muted">
                {ed.date} · {ed.location}
              </p>
              <h3 className="mt-1.5 font-serif text-xl sm:text-2xl font-medium text-ink">
                {ed.degree}
              </h3>
              <p className="mt-0.5 text-sm font-sans font-medium text-terra">{ed.institution}</p>
              <p className="mt-3 text-sm sm:text-base text-ink2 leading-relaxed">{ed.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Education;
